<template>
  <v-card elevation="1" class="editor" v-if="editor">
    <div class="menubar">
      <!-- <v-btn
        icon
        class="menubar__button"
        @click="onImageButtonClick"
      >
        <v-icon> image </v-icon>
      </v-btn>
      <input
          ref="uploader"
          type="file"
          accept="image/*"
          style="display: none"
          @change="(e) => onFileChanged(e)"
        > -->
      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }"
      >
        <v-icon> format_bold </v-icon>
      </v-btn>
      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }"
      >
        <v-icon> format_italic </v-icon>
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }"
      >
        <v-icon> strikethrough_s </v-icon>
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }"
      >
        P
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
      >
        H1
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
      >
        H2
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
      >
        H3
      </v-btn>

      <!-- <v-btn
        icon
        @click="editor.chain().focus().setTextAlign('left').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }"
      >
        <v-icon> format_align_left </v-icon>
      </v-btn>

      <v-btn
        icon
        @click="editor.chain().focus().setTextAlign('center').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }">
        <v-icon> format_align_center </v-icon>
      </v-btn>

      <v-btn
        icon
        @click="editor.chain().focus().setTextAlign('right').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }">
        <v-icon> format_align_right </v-icon>
      </v-btn>

      <v-btn
        icon
        @click="editor.chain().focus().setTextAlign('justify').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }">
        <v-icon> format_align_justify </v-icon>
      </v-btn> -->

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }"
      >
        <v-icon> format_list_bulleted </v-icon>
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }"
      >
        <v-icon> format_list_numbered </v-icon>
      </v-btn>

        <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }"
      >
        <v-icon> format_quote </v-icon>
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().setHorizontalRule().run()"
      >
        <v-icon> horizontal_rule </v-icon>
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().undo().run()"
      >
        <v-icon> undo </v-icon>
      </v-btn>

      <v-btn
        icon
        class="menubar__button"
        @click="editor.chain().focus().redo().run()"
      >
        <v-icon> redo </v-icon>
      </v-btn>
    </div>
    <editor-content class="editor__content" :editor="editor" />
  </v-card>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
// import TextAlign from '@tiptap/extension-text-align'
// import Image from '@tiptap/extension-image'
import resizeImage from '@/plugins/imageResize.js'
import AliOssService from '../services/AliOssService'
import config from '../config/index.ts'

export default {
  components: {
    EditorContent
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
  },
  watch: {
    value (value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = this.editor.getJSON().toString() === value.toString()

      if (isSame) {
        return
      }

      this.editor.commands.setContent(this.value, false)
    }
  },
  data () {
    return {
      editor: null
    }
  },
  mounted () {
    this.editor = new Editor({
      extensions: [
        StarterKit
        // TextAlign,
        // Image
      ],
      content: this.value,
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      }
    })
  },
  beforeDestroy () {
    this.editor.destroy()
  },
  methods: {
    onImageButtonClick () {
      this.$refs.uploader.click()
    },
    async onFileChanged (e) {
      const file = e.target.files[0]
      console.log(`file selected: filename: ${file.name}`)
      // compress the image if necessary
      const resizedImage = await resizeImage({ file: file, maxSize: config.imageMaxSizePx })
      // const imgFileUrl = URL.createObjectURL(resizedImage)
      const imgFile = new File([resizedImage], 'programContentImage_' + file.name) // convert blob to file for uploading
      const { imgUrl, fileName } = await AliOssService.uploadToAliOss({ file: imgFile, publicRead: true }) // 上传至公共读区域
      if (imgUrl) {
        this.editor.chain().focus().setImage({ src: imgUrl, alt: fileName }).run()
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menubar {
  padding: 1em;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.is-active {
  background-color:lightgrey;
}
.editor {
  border-style: solid;
  border-width: 1px;
  padding: 0em;
}
.editor__content {
  padding: 1em;
  height: 100%;
}
/* use >>> as deep selector to control img under this .editor__content class */
.editor__content >>> img {
  max-width: 100%;
  height: auto;
  background-color: transparent;
}
</style>
